export default {
  'Choose File': 'Dosya seçin',
  'Please paste a URL': 'Lütfen bir URL yapıştırın',
  'Loading': 'Yükleniyor',
  'Analyzing': 'Analiz',
  'Try a sample': 'Bir örnek deneyin',
  'Sorry, error occurs when analyzing the URL.': 'Maalesef, URL analiz edilirken hata oluşuyor.',
}